import classes from './ContactHeader.module.css'
import ContactIconHeader from './ContactIconHeader/ContactIconHeader';

const ContactHeader = ({iconStyles, textStyles, data}) => {

	const iWidth = '30px';
	const iHeight = '30px';

	return (
		<div className={classes.container}>
			{
				Object.entries(data).map(([type, info], index) =>
					<ContactIconHeader type={type}
									   key={index}
									   iStyle={{marginLeft:'30px', ...iconStyles}}
									   tStyle={textStyles}
									   info={info}/>)
			}
		</div>
	);
};

export default ContactHeader;
